import { Users, MessageCircle, Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "./Shared";
import { IMAGES } from "../config";

const POINTS = [
  [Users, "A room of builders", "Entrepreneurs, creators, coaches, and authors doing the same identity work — not just consuming content."],
  [MessageCircle, "Real conversations", "Share your message drafts, offer ideas, and wins — and get reflections from people on the same path."],
  [Sparkles, "Direct proximity", "Access to Dasha Love’s community space, prompts, and live threads as the BLUEPRINT movement grows."],
];

export default function Skool() {
  return (
    <section data-testid="skool-section" className="relative py-20 sm:py-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>Skool community access included</Eyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display font-extrabold uppercase tracking-tight leading-[0.95] text-3xl sm:text-5xl">
              You don&rsquo;t build this{" "}
              <span className="font-serif italic normal-case font-medium text-lime">alone.</span>
            </h2>
          </Reveal>
          <div className="mt-10 space-y-8">
            {POINTS.map(([Icon, title, desc], i) => (
              <Reveal key={title} delay={i * 0.08}>
                <div className="flex gap-5">
                  <span className="w-10 h-10 shrink-0 border border-lime/40 text-lime flex items-center justify-center">
                    <Icon size={17} />
                  </span>
                  <div>
                    <h3 className="font-display font-bold uppercase tracking-tight text-base sm:text-lg">
                      {title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-fog">{desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.15} className="lg:col-span-6">
          <div
            data-testid="skool-community-card"
            className="relative border border-cream/15 bg-coal shadow-[0_40px_80px_-30px_rgba(0,0,0,0.9)] overflow-hidden"
          >
            <div className="flex items-center justify-between px-5 py-4 border-b border-cream/10">
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 bg-lime text-ink font-display font-extrabold text-sm flex items-center justify-center">
                  B
                </span>
                <div>
                  <p className="font-display font-bold uppercase tracking-tight text-sm">
                    Blueprint™ Community
                  </p>
                  <p className="font-mono text-[9px] tracking-[0.2em] uppercase text-fog">
                    on Skool · Private
                  </p>
                </div>
              </div>
              <span className="flex items-center gap-1.5 font-mono text-[9px] tracking-[0.15em] uppercase text-lime">
                <span className="w-1.5 h-1.5 rounded-full bg-lime animate-pulse" />
                Live
              </span>
            </div>
            <div className="relative h-[340px] sm:h-[440px] overflow-hidden group">
              <img
                src={IMAGES.skool}
                alt="The actual BLUEPRINT classroom on Skool — lessons and the Your Why Identity Masterclass"
                className="w-full h-auto object-top transition-transform duration-[3500ms] ease-out group-hover:-translate-y-[32%]"
                loading="lazy"
              />
              <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-coal to-transparent" />
              <span className="absolute bottom-3 left-4 font-mono text-[9px] tracking-[0.2em] uppercase text-lime bg-ink/70 backdrop-blur px-2.5 py-1 border border-cream/15">
                Hover to scroll the real classroom
              </span>
            </div>
            <p className="px-5 py-4 font-mono text-[9px] tracking-[0.2em] uppercase text-fog border-t border-cream/10">
              Actual screenshot — 25+ lessons, masterclasses + live group sessions inside
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
